import axios from 'axios';

const CUSTOMER_ID = process.env.REACT_APP_MESSAGE_CENTRAL_CUSTOMER_ID;
const KEY = process.env.REACT_APP_MESSAGE_CENTRAL_KEY;

// In dev the proxy (setupProxy.js) forwards /auth/v1 and /verification/v3
// to cpaas.messagecentral.com, avoiding browser CORS restrictions.
const BASE = process.env.NODE_ENV === 'development'
  ? ''
  : 'https://cpaas.messagecentral.com';

export async function getMCToken() {
  const response = await axios.get(`${BASE}/auth/v1/authentication/token`, {
    params: { customerId: CUSTOMER_ID, key: KEY, scope: 'NEW' },
  });
  const token = response.data?.token;
  if (!token) throw new Error('MessageCentral auth failed');
  return token;
}

export async function sendOtp(mobileNumber, countryCode = '+91') {
  const token = await getMCToken();

  const formData = new FormData();
  formData.append('countryCode', countryCode.substring(1));
  formData.append('flowType', 'SMS');
  formData.append('customerId', CUSTOMER_ID);
  formData.append('mobileNumber', mobileNumber);

  const response = await axios.post(`${BASE}/verification/v3/send`, formData, {
    headers: {
      authToken: token,
      'Content-Type': 'multipart/form-data',
    },
  });

  const verificationId = response.data?.data?.verificationId;
  const errorMsg = response.data?.data?.errorMessage;
  if (errorMsg != null && errorMsg !== 'Success') throw new Error(errorMsg);
  if (!verificationId) throw new Error('Failed to send OTP');
  return { verificationId, authToken: token };
}

export async function verifyOtp(verificationId, code, authToken) {
  const response = await axios.get(`${BASE}/verification/v3/validateOtp`, {
    params: { customerId: CUSTOMER_ID, code, verificationId },
    headers: { authToken },
  });
  return response.data;
}
